import type React from 'react';

export const Quote: React.FC = () => {
  return <span>This is a quote example</span>;
};
